import React from 'react';
import { Input, Label, FormGroup } from 'reactstrap';

const ContactSection = ({ formData, onChange, errors = {}, showPatente = true }) => {
  return (
    <>
      <div className="d-flex align-items-center my-2">
        <div className="flex-grow-1 border-top"></div>
        <span className="mx-3 text-muted fw-bold">Datos de contacto</span>
        <div className="flex-grow-1 border-top"></div>
      </div>

      {showPatente && (
        <div className="row">
          <div className="col-12">
            <FormGroup>
              <Label for="patente">Patente</Label>
              <Input
                type="text"
                id="patente"
                name="patente"
                value={formData.patente || ''}
                onChange={onChange}
                placeholder="Ej: ABC123"
                required
                invalid={!!errors.patente}
              />
              {errors.patente && (
                <div className="text-danger small">{errors.patente}</div>
              )}
            </FormGroup>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-12">
          <FormGroup>
            <Label for="contacto">Nombre contacto</Label>
            <Input
              type="text"
              id="contacto"
              name="contacto"
              value={formData.contacto || ''}
              onChange={onChange}
              placeholder="Ej: Jorge Gonzalez"
              invalid={!!errors.contacto}
            />
            {errors.contacto && (
              <div className="text-danger small">{errors.contacto}</div>
            )}
          </FormGroup>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <FormGroup>
            <Label for="email">Email</Label>
            <Input
              type="email"
              id="email"
              name="email"
              value={formData.email || ''}
              onChange={onChange}
              placeholder="Ej: correo@ejemplo.cl"
              invalid={!!errors.email}
            />
            {errors.email && (
              <div className="text-danger small">{errors.email}</div>
            )}
          </FormGroup>
        </div>
        <div className="col-6">
          <FormGroup>
            <Label for="telefono">Teléfono</Label>
            <Input
              type="text"
              id="telefono"
              name="telefono"
              value={formData.telefono || ''}
              onChange={onChange}
              placeholder="Ej: 987654321"
              invalid={!!errors.telefono}
            />
            {errors.telefono && (
              <div className="text-danger small">{errors.telefono}</div>
            )}
          </FormGroup>
        </div>
      </div>
    </>
  );
};

export default ContactSection;
